<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card
          rounded="sm"
          elevation="3"
        >
          <v-card-title class="font-weight-bold">
            A versão de acesso da sua plataforma mudou
          </v-card-title>
          <v-divider />
          <v-card-text class="text-black">
            A versão de acesso à sua plataforma mudou para a versão {{ new_plan }}. 
            <p>
              Aguarde a liberação para acessar a plataforma novamente. Qualquer dúvida, entre em contato com a sua coordenação.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import { mapGetters } from "vuex";

export default {
  computed:{
    ...mapGetters(['plan','new_plan','authUser']),
  }
}
</script>
